class Controller {
  constructor($injector, $stateParams) {
    "ngInject";

    this.$stateParams = $stateParams;
    this.Events = $injector.get("Events");
    this.activeParams = this.$stateParams;
    this.paginateEvent = this.Events.getPaginateEvent(
      "corporateContractApprovals"
    );
    this.filterEvent = this.Events.getFilterEvent("corporateContractApprovals");
    this.sortEvent = this.Events.getSortEvent("corporateContractApprovals");
    this.contractParams = {
      isCityRequired: false,
    };
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/corporateContractApprovals/corporateContractApprovals.controller.js